import React, { useState } from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from '../../components/Loader/Loader';
import toast from 'react-hot-toast';

const ContactForm = () => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      company: '',
      message: '',
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, 'Only letters and spaces allowed')
        .required('**Name is required'),

      email: Yup.string()
        .email('**Invalid email address')
        .required('**Email is required'),

      phone: Yup.string()
        .matches(/^[0-9+\-\s()]+$/, '**Invalid phone number')
        .required('**Phone is required'),

      company: Yup.string()
        .min(2, '**Company name is too short')
        .required('**Company is required'),

      message: Yup.string().required('**Message is required'),
    }),

    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      try {
        const response = await axios.post(
          process.env.REACT_APP_CONTACTS_URL,
          {
            name: values.name,          // 👈 IMPORTANT
            email: values.email,
            mobile: values.phone,
            company: values.company,
            message: values.message,
          }
        );

        if (response.data.success) {
          toast.success('Thank you! Your message has been sent successfully.');
          resetForm();
        } else {
          toast.error(response.data.error || 'Something went wrong.');
        }
      } catch (error) {
        console.error(error);
        toast.error('Server error. Please try again later.');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      {loading && <Loader />}

      <form onSubmit={formik.handleSubmit} className="contact-form">
        <div className="row">

          <div className="col-lg-6">
            <div className="input-field">
              <label>Name*</label>
              <div className="input-box">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="errorMessage" style={{ padding: 10 }}>
                    {formik.errors.name}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="input-field">
              <label>Email*</label>
              <div className="input-box">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="errorMessage" style={{ padding: 10 }}>
                    {formik.errors.email}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="input-field">
              <label>Phone*</label>
              <div className="input-box">
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className="errorMessage" style={{ padding: 10 }}>
                    {formik.errors.phone}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="input-field">
              <label>Company*</label>
              <div className="input-box">
                <input
                  type="text"
                  name="company"
                  className="form-control"
                  value={formik.values.company}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.company && formik.errors.company && (
                  <div className="errorMessage" style={{ padding: 10 }}>
                    {formik.errors.company}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="input-field text-field">
              <label>Message*</label>
              <div className="input-box">
                <textarea
                  name="message"
                  className="form-control"
                  placeholder="How can we help you?"
                  value={formik.values.message}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.message && formik.errors.message && (
                  <div className="errorMessage" style={{ padding: 10 }}>
                    {formik.errors.message}
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>

        <div className="cp-det-btn mt-20 d-grid">
          <button className="cp-btn" type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send us a message'}
            <i className="fal fa-arrow-right"></i>
          </button>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
